"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "ChartArrow___StyledSvg",
  componentId: "sc-28todu-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

function ChartArrow(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M72 282.013v-63.004h42c5.565 0 10.92-2.205 14.847-6.153L156 185.723l48.153 48.134c8.211 8.212 21.483 8.212 29.694 0L261 206.724l27.153 27.133c4.095 4.116 9.471 6.154 14.847 6.154 5.376 0 10.752-2.038 14.847-6.154l90.132-90.136-.042 138.292H72zm336-210.01v12.306L303 189.314l-27.153-27.154c-8.211-8.19-21.483-8.19-29.694 0L219 189.314l-48.153-48.155c-8.211-8.19-21.483-8.19-29.694 0l-35.847 35.848H72V72.002h336zM408 30H72c-23.163 0-42 18.838-42 42.002v210.01c0 23.165 18.837 42.003 42 42.003h117.285L63.306 450h59.388L219 353.71V450h42v-96.29L357.306 450h59.388L290.715 324.015H408c23.163 0 42-18.838 42-42.002V72.003C450 48.837 431.163 30 408 30z"
  }));
}

var _default = ChartArrow;
exports["default"] = _default;